import React from 'react'

export interface CardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = '', onClick, ...rest }, ref) => {
    const isClickable = !!onClick

    const classes = [
      'bg-white rounded-warmer p-5 transition-all duration-200',
      'shadow-[0_1px_3px_rgba(26,17,10,0.06)] border border-silver-light/60',
      isClickable
        ? 'cursor-pointer hover:shadow-[0_4px_12px_rgba(26,17,10,0.08)] hover:-translate-y-0.5 focus-visible:ring-2 focus-visible:ring-green'
        : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div
        ref={ref}
        className={classes}
        onClick={onClick}
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onKeyDown={
          isClickable
            ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onClick?.()
                }
              }
            : undefined
        }
        {...rest}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'

export default Card
